import { render, staticRenderFns } from "./groupBuying2.vue?vue&type=template&id=3481186c&"
import script from "./groupBuying2.vue?vue&type=script&lang=js&"
export * from "./groupBuying2.vue?vue&type=script&lang=js&"
import style0 from "./groupBuying2.vue?vue&type=style&index=0&id=3481186c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports